<template>
  <section class="customers-read-profile">
    <former-container>
      <former-section-list
        v-for="section in visibleSections"
        :key="section.id"
        :editable="section.editable"
        :section="section"
        @change="change"
      />
    </former-container>
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSectionList from '@/components/Former/Section/List.vue';

  import former from '@/helpers/mixins/former';
  import customersRead from '@/views/Customers/Form/mixin';

  import {
    attachmentMaps, // ARRAY!
  } from '@/views/Customers/Form/maps';

  import {
    sectionsPF,
    sectionsPJ,
  } from '@/views/Customers/Form/sections';

  export default {
    name: 'CustomersRead',
    components: {
      FormerContainer,
      FormerSectionList,
    },
    mixins: [
      former,
      customersRead,
    ],
    props: {
      collapsed: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isPj: false,
        sections: [
          ...sectionsPF(),
        ],
      };
    },
    computed: {
      ...mapState([
        'attachments',
        'customers',
        'domainsWeb',
      ]),

      customer() {
        return this.customers.read.item;
      },

      visibleSections() {
        const visible = this.sections
          .map((section, index) => ({
            ...section,
            collapsable: true,
            startCollapsed: this.collapsed ? !!index : false,
            copyable: true,
            editable: false,
          }))
          .map(section => ({
            ...section,
            items: section.items
              .filter(item => item.type !== 'file'),
          }));

        visible.splice(1, 0, {
          id: 'customerUploads',
          title: 'Arquivos',
          subtitle: 'Comprovantes anexados',
          collapsable: true,
          startCollapsed: this.collapsed,
          editable: false,
          items: this.sections.reduce((list, section) => {
            const files = section.items
              .filter(item => item.type === 'file' && !item.id.match('OCRFile'));

            if (files.length) {
              return list.concat(files);
            }

            return list;
          }, []),
        });

        return visible;
      },
    },
    mounted() {
      Promise
        .all([
          this.getDomainsWeb(),
          this.getBanksWeb(),
        ])
        .finally(() => {
          this.setSection();

          this.setAttachmentsList();
          this.setValues();
        });
    },
    methods: {
      setSection() {
        if (!this.customer.cpf && this.customer.cnpj) {
          this.sections = [
            ...sectionsPJ(),
          ];

          try {
            this.gotDomainsWeb();
            this.gotBanksWeb();
            this.gotAttachments();
          } catch (err) {
            this.getDomainsWeb();
            this.getBanksWeb();
          }
        }
      },

      change(id, value) {
        const field = this.getField(id);

        const personType = this.domainsWeb.list.items.person_attachment_type
          .find(t => t.identifier === field.meta.type) || {};

        const type = this.domainsWeb.list.items.attachment_type
          .find(t => t.identifier === field.meta.type) || {};

        const found = this.customer.attachments
          .find(attachment => [personType.id, type.id].indexOf(attachment.attachment_type_id) > -1);

        const payload = {
          id: this.customer.id,
          customer: {
            attachments: null,
          },
        };

        if (value) {
          let json;

          try {
            json = JSON.parse(value);
          } catch (err) { /* */ }

          if (json && json.key && json.name) {
            json = {
              remote_file_id: json.key,
              original_filename: json.name,
              attachment_type_id: type.id,
            };

            if (found) {
              json.id = found.id;
            }

            payload.customer.attachments = [json];
          }
        } else if (found) {
          payload.customer.attachments = [{
            id: found.id,
            _destroy: true,
          }];
        }

        if (payload.customer.attachments) {
          this.setFieldValue(id, value);

          this.$store
            .dispatch('customers/update', payload)
            .catch(() => {
              this.setFieldValue(id, '');
              this.setFieldErrors(id, ['não foi possível enviar o arquivo']);
            });
        }
      },
      gotNewAttachment(data) {
        const { type } = data;

        const key = attachmentMaps
          .find(id => this.getField(id).meta.type === type);

        if (!key) {
          return;
        }

        this.updateAttachmentList(key, type);

        this.change(key, JSON.stringify({
          name: data.filename,
          key: data.key,
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';
</style>
